<script lang="ts">
  import { getAppConfig } from '../../../common/config/app-config.js';
  import { getDateStringInCurrentLang } from '../../../common/util.js';
  import Icon from '../../common/components/Icon.svelte';
  import Text from '../../common/components/Text.svelte';
  export let data: any = {};
  const { lang } = getAppConfig();
</script>

{#if data?.deliveryLeadTimeNow}
  <div class="c_deliverydate d-flex align-items-center gap-3">
    <div class="delivery-icon">
      <Icon glyph="icon-standard_delivery_plain" type="primary" mobileSize={32} desktopSize={32} />
    </div>
    <Text key="extra.preorder.delivery.start.text" />
    <span>
      {data.deliveryLeadTimeNow}
    </span>
  </div>
{/if}
{#if data?.deliveryLeadTimeBefore !== null}
  <div class="c_deliverydate d-flex align-items-center gap-3">
    <div class="delivery-icon">
      <Icon glyph="icon-standard_delivery_plain" type="primary" mobileSize={32} desktopSize={32} />
    </div>
    <div class="info">
      <Text key="product.dlt.order.before" args={[data?.deliveryLeadTimeBefore]} />
      <span><strong>{getDateStringInCurrentLang(data?.deliveryLeadTimeBeforeBy, lang)}</strong></span>
    </div>
  </div>
{/if}
